import React from "react";
import { Icon } from "@iconify/react";
import DataManagement from "../../components/table/DataManagement.jsx";
import { useNavigate, Link } from "react-router-dom";

import { useTerceros } from "../../hooks_cache/useTerceros.js";
import { useComprobantes } from "../../hooks_cache/useComprobantes.js";

function TercerosTable() {
  const navigate = useNavigate();
  const { data: terceros, refetch } = useTerceros();
  const { data: comprobantes = [] } = useComprobantes();

  const totales = React.useMemo(() => {
    return comprobantes
      .filter((c) => c.naturaleza === "venta" && c.estado === "pendiente")
      .reduce((acc, c) => {
        const id = c.Tercero?.id;
        if (!id) return acc;

        acc[id] = (acc[id] || 0) + Number(c.pendiente || 0);
        return acc;
      }, {});
  }, [comprobantes]);

  const tipoTerceroColumn = React.useMemo(
    () => ({
      accessorKey: "tipo_tercero",
      header: "TIPO DE TERCERO",
      cell: ({ row }) => {
        const { es_cliente, es_proveedor } = row.original;
        if (es_cliente && es_proveedor)
          return (
            <>
              <span className="badge bg-green">CLIENTE</span> <span className="badge bg-primary">PROVEEDOR</span>
            </>
          );
        if (es_cliente) return <span className="badge bg-green">CLIENTE</span>;
        if (es_proveedor) return <span className="badge bg-primary">PROVEEDOR</span>;
        return "No Definido";
      },
    }),
    [terceros]
  );

  const nombreColumn = React.useMemo(
    () => ({
      accessorKey: "nombre",
      header: "RAZON SOCIAL",
      cell: ({ row }) => {
        const { id, nombre } = row.original;
        return (
          <Link to={`/tercero/${id}`} className="fw-bold text-nowrap">
            {nombre}
          </Link>
        );
      },
    }),
    [terceros]
  );

  const pendienteColumn = React.useMemo(
    () => ({
      id: "pendiente",
      header: "PENDIENTE ($)",
      cell: ({ row }) => {
        const idTercero = row.original.id;
        const total = totales[idTercero] || 0;

        return <span className={total > 0 ? "fw-bold text-danger" : "text-muted"}>${total.toFixed(2)}</span>;
      },
    }),
    [totales]
  );

  const columnsWithPendiente = React.useMemo(
    () => [
      { accessorKey: "nrc", header: "NRC" },
      nombreColumn,
      { accessorKey: "nit", header: "NIT" },
      { accessorKey: "correo", header: "CORREO" },
      pendienteColumn,
      tipoTerceroColumn,
    ],
    [pendienteColumn]
  );

  return (
    <DataManagement
      columns={columnsWithPendiente}
      data={terceros}
      title="Gestion de terceros"
      actions={[
        <button onClick={() => navigate(`/tercero`)} className="btn btn-primary btn-sm d-flex me-2 pe-3 rounded-3">
          <Icon className="iconify fs-18px me-2 ms-n1" icon="solar:add-circle-bold-duotone" />
          Agregar tercero
        </button>,
        <button onClick={refetch} className="btn btn-theme btn-sm d-flex pe-3 rounded-3">
          <Icon className="iconify fs-18px me-2 ms-n1" icon="solar:refresh-bold-duotone" />
          Refrescar tabla
        </button>,
      ]}
    />
  );
}

export default TercerosTable;
